<audio style="width: 0; height: 0" #audioElement [src]="src" controls></audio>
{{ duration | number: '1.2-2' | replaceText: {',' : ':', "." : ":"} }}